import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { footerLegacy } from './footerLegacy.vanilla.mjs';

const ModalFooter = forwardRef(
  function ModalFooter_Legacy({ className: classNameFromProps, ...props }, ref) {
    const className = classNames(footerLegacy, classNameFromProps);
    return /* @__PURE__ */ jsx(
      StyledFooter,
      {
        "data-scope": "modal",
        "data-part": "footer_legacy",
        className,
        ref,
        ...props
      }
    );
  }
);
const StyledFooter = styled("footer");
ModalFooter.toString = () => '[data-scope="modal"][data-part="footer_legacy"]';

export { ModalFooter as ModalFooter_Legacy };
//# sourceMappingURL=Footer_Legacy.mjs.map
